'use client';

import { ExpandableContent } from '@/components/expandable-content';
import Container from '@/components/layouts/container';
import type { AboutSection } from '@/types/about';

type BannerContentProps = {
  content: AboutSection['content'];
};

export default function BannerContent({ content }: BannerContentProps) {
  if (!content) {
    return null;
  }

  return (
    <Container
      as='section'
      className='mb-8 mt-10 sm:my-12 md:my-16 lg:mb-24 lg:mt-20 xl:mb-28 xl:mt-24'
    >
      <ExpandableContent
        content={content}
        buttonPosition='right'
        collapseOnBreakpoint
      />
    </Container>
  );
}
